define("Magento_Ui/js/lib/logger/levels-pool",["underscore"],(function(e){"use strict";var n,r;return n={NONE:0,ERROR:1,WARN:2,INFO:3,DEBUG:4,ALL:5},r=e.invert(n),{getLevels:function(){return n},getNameByCode:function(e){return r[e]}}}));
